import { Link } from "react-router-dom";
import { ExampleLabel } from "./ExampleLabel";

export function Companion() {
  return (
    <section className="sec card" id="companion">
      <div className="companion">
        <div className="companion-copy">
          <div className="eyebrow"><span className="dot" /> The brain in motion · AI Companion</div>
          <h2>
            Your trip, <em>orchestrated.</em>
          </h2>
          <p>
            The Companion is your second brain in active mode. It already knows your loyalty status, your travelers,
            your budget patterns, and your home airports. It rides with you from request to return, with full memory of every prior trip.
          </p>
          <Link to="/companion" className="btn btn-primary">Meet Companion</Link>
        </div>

        <div className="companion-example">
          <ExampleLabel />
          <div className="companion-chat">
            <div className="chat-head">
              <span className="t">Voy Companion · Session #28421</span>
              <span className="status"><span className="dot" />Live</span>
            </div>
            <div className="msg user">Anniversary in Lisbon, first week of June. Keep us under $2,400 total for 2.</div>
            <div className="msg bot">
              <div className="b-title">Found 3 itineraries under budget</div>
              <div className="line"><span>SF → LIS · TAP 208 · Jun 2</span><span className="voy">$744</span></div>
              <div className="line"><span>Boutique · Chiado, 5 nts</span><span className="voy">$1,085</span></div>
              <div className="line"><span>Transfers + day 3 wine tour</span><span className="voy">$310</span></div>
              <div className="line" style={{ border: 0, marginTop: 6 }}>
                <span style={{ color: "var(--v6-fg-strong)", fontWeight: 700 }}>Total</span>
                <span className="voy">$2,139</span>
              </div>
            </div>
            <div className="msg user">Book it. Add lounge access for the outbound.</div>
            <div className="msg bot">
              <div className="b-title">Locked in. Confirmation #VOY-7G3K2</div>
              <div style={{ fontSize: 13, color: "var(--v6-fg-body)" }}>
                Plaza Premium at SFO added ($42). Visa: none required. I'll ping you 24h before departure.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
